import React from 'react';

const SuccessModal = ({ onClose }) => {
  return (
    <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-center p-4">
          <div className="modal-body">
            <h5 className="mb-3 text-success">✅ Thank you for shopping with us!</h5>
            <button className="btn btn-success mt-3" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
